export enum UserActionTypeBackupConfigured {
  UsersConfiguredBackup = 'UsersConfiguredBackup',
  DomainConfiguredBackup = 'DomainConfiguredBackup',
  UserTurnedOnOff = 'UserTurnedOnOff',
  AllUsersTurnedOn = 'AllUsersTurnedOn'
}
